import { useAuth0 } from "@auth0/auth0-react";
//import { Show, SimpleShowLayout, TextField, DateField, RichTextField, Labeled,SimpleForm } from 'react-admin';
import React, { Fragment } from "react";

export const UserProfile = () => {
    const { user } = useAuth0();
    const { name, family_name, picture, email, address, birthdate, phone_number } = user;

  return (
    <Fragment>
      <div className="container flex-grow-1">
        <div>
          <div className="row align-items-center profile-header">
            <div className="col-md-2 mb-3">
              <img
                src={picture}
                alt="Profile"
                className="rounded-circle img-fluid profile-picture mb-3 mb-md-0"
              />
            </div>
            <div className="col-md text-center text-md-left">
              <h2>{name}</h2>
              <p className="lead text-muted">{email}</p>
            </div>
          </div>
          <div className="row">
            <label>Name:</label>
            <p>{name}</p>
          </div>
          <div className="row">
            <label>Family Name:</label>
            <p>{family_name}</p>
          </div>
          <div className="row">
            <label>Email:</label>
            <p>{email}</p>
          </div>
          <div className="row">
            <label>Birth Date:</label>
            <p>{birthdate}</p>
          </div>
          <div className="row">
            <label>Address:</label>
            <p>{address}</p>
          </div>
          <div className="row">
            <label>Phone number:</label>
            <p>{phone_number}</p>
          </div>
        </div>
      </div>
    </Fragment>
  );

}


// export const UserProfile = () => {
//   const { user } = useAuth0();
//   const { name, family_name, picture, email, address, birthdate, phone_number } = user;
// return (

//         <SimpleShowLayout>
//           <Labeled label="Nombre: "/>
//           <TextField source={name}/>
//           <TextField source="username" />
//           <TextField source="email" />
//           <TextField source="phone" />
//           <TextField source="company"/>
//         </SimpleShowLayout>

// );

// }



// export const UserProfile = (data) => {
//     const { user } = useAuth0();
//     return (
//         <div><p>Hello world!{user.nickname}</p></div>
//     );
// }